import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

export const TableSimples = ({ headers, rows, total, maxHeight }: TableSimplesProps) => {
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    const formatValue = (value: string | number | React.ReactNode, monetary?: boolean) => {
        if (React.isValidElement(value)) {
            return value;
        }
        
        if (monetary && typeof value === 'number') {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
        return value;
    };

    return (
        <TableContainer sx={{ maxHeight: maxHeight }}>
            <Table size="small" aria-label="tabela simples">
                <TableHead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell
                                key={index}
                                align={header.numeric ? "right" : "left"}
                                sx={paddingStyle}
                            >
                                <b>{header.label}</b>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            {row.columns.map((column, colIndex) => (
                                <TableCell
                                    key={colIndex}
                                    component={colIndex === 0 ? "th" : "td"}
                                    scope={colIndex === 0 ? "row" : undefined}
                                    align={column.numeric ? "right" : "left"}
                                    sx={paddingStyle}
                                >
                                    {formatValue(column.value, column.monetary)}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}

                    {total && (
                        <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell colSpan={1} component="th" scope="row" sx={paddingStyle}>
                                <b>{total.label}</b>
                            </TableCell>
                            <TableCell colSpan={headers.length -1} align="right" sx={paddingStyle}>
                                <b>{formatValue(total.value, total.monetary)}</b>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export interface TableSimplesProps {
    headers: {
        label: string;
        numeric?: boolean;
    }[];
    rows: {
        columns: {
            value: string | number | React.ReactNode;
            numeric?: boolean;
            monetary?: boolean;
        }[];
    }[];
    total?: {
        label: string;
        value: string | number;
        monetary?: boolean;
    };
    maxHeight?: number | string;
}